import type {DismissibleToastProps} from '@Components/dismissible-toast/dismissible-toast.types';
import {renderElement} from '@Utils/root-element.util';
import {DismissibleToast} from '@Components/dismissible-toast/dismissible-toast';

window.PMW.mergePMW(PMW, {
  showToast: (opts: DismissibleToastProps) => {
    const toast = document.body.querySelector('.pmw-toast-container');

    if (toast) {
      toast.remove();
    }

    const conatiner = document.createElement('div');
    conatiner.classList.add('pmw-toast-container');
    conatiner.classList.add('_position-fixed');
    renderElement(conatiner, <DismissibleToast {...opts} />);
    document.body.appendChild(conatiner);
  },
});
